<!--
 * @Author: Tina Huang
 * @Date: 2024-01-11 14:53:16
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-12 15:48:53
 * @Description: 
-->
<template>
  <el-container class="jiexi">
    <el-aside>
      <h4>系列目录</h4>
      <ul>
        <li
          v-for="(item, index) in menu"
          :key="item.id"
          @click="handleCourse(item.id)"
        >
          Vol.{{ index + 1 }} <span v-html="item.title" />
        </li>
      </ul>
    </el-aside>
    <el-main>
      <h2>❤️ 即将上架，敬请期待 ❤️</h2>
      <p>后续将开展直播答疑以及教程和模板解析～</p>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      menu: [
        {
          id: "basic",
          title: "基本公式解析",
        },
        {
          id: "database",
          title: "Database的高级用法介绍",
        },
        {
          id: "button",
          title: "快捷按钮的妙用",
        },
        {
          id: "template",
          title: "模板设计思路和扩展",
        },
        {
          id: "make-j",
          title: "简单模板解析<strong>（积分打卡）</strong>",
        },
      ],
    };
  },
  methods: {
    handleCourse(id) {
      this.$message({
        message: "即将上架，敬请期待～",
        type: "warning",
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import url(../../less/var.less);
.jiexi {
  // color: #333;
  font-size: 16px;
  padding-top: 20px;
}
h2 {
  font-size: 30px;
  text-align: center;
}
p {
  text-align: center;
}
.el-aside {
  background: @third-color;
  box-sizing: border-box;
  padding: 20px;
  width: 300px !important;
  margin-top: 30px;
  h4 {
    margin-top: 0;
  }
  ul {
    padding: 0;
  }
  li {
    list-style: none;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    &:hover {
      background: @normal-bg;
    }
  }
}
</style>